import React from 'react';
export function HowItWorksSection() {
  return <section className="py-16 md:py-24 px-4 bg-cream-dark" data-id="element-255">
      <div className="max-w-5xl mx-auto" data-id="element-256">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-257">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-navy/10" data-id="element-258"></div>

          {/* Step 1 */}
          <div className="relative flex flex-col items-center text-center" data-id="element-259">
            <div className="w-16 h-16 rounded-full bg-white border border-navy/10 shadow-sm flex items-center justify-center text-2xl font-serif font-bold text-navy mb-6 relative z-10" data-id="element-260">
              1
            </div>
            <h3 className="text-xl font-bold text-navy mb-3 font-serif" data-id="element-261">
              Compra segura
            </h3>
            <p className="text-navy/70 font-sans leading-relaxed" data-id="element-262">
              Pago protegido. Menos de 2 minutos.
            </p>
          </div>

          {/* Step 2 */}
          <div className="relative flex flex-col items-center text-center" data-id="element-263">
            <div className="w-16 h-16 rounded-full bg-white border border-navy/10 shadow-sm flex items-center justify-center text-2xl font-serif font-bold text-navy mb-6 relative z-10" data-id="element-264">
              2
            </div>
            <h3 className="text-xl font-bold text-navy mb-3 font-serif" data-id="element-265">
              Recibe 4 PDFs
            </h3>
            <p className="text-navy/70 font-sans leading-relaxed" data-id="element-266">
              Llegan a tu correo en segundos.
            </p>
          </div>

          {/* Step 3 */}
          <div className="relative flex flex-col items-center text-center" data-id="element-267">
            <div className="w-16 h-16 rounded-full bg-white border border-navy/10 shadow-sm flex items-center justify-center text-2xl font-serif font-bold text-navy mb-6 relative z-10" data-id="element-268">
              3
            </div>
            <h3 className="text-xl font-bold text-navy mb-3 font-serif" data-id="element-269">
              Aplica desde hoy
            </h3>
            <p className="text-navy/70 font-sans leading-relaxed" data-id="element-270">
              Empieza con las 3 acciones del Capítulo 1.
            </p>
          </div>
        </div>
      </div>
    </section>;
}